import { IEntity } from 'viggo-sistemas-core-web';

import { IParceiro } from '@app/modules/parceiro/model';

export enum TIPO_TAC {
  AGREGADO = 'AGREGADO',
  INDEPENDENTE = 'INDEPENDENTE',
  OUTROS = 'OUTROS'
}

export interface IProprietarioVeiculo extends IEntity {
  parceiro: IParceiro;
  domain_id: string;
  codigo: number;
  rntrc: string;
  taf: string;
  registro_estadual: string;
  tipo_tac: TIPO_TAC;
}
